<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">
          {{ $t("coupon_code.label") }}
        </div>
        <span class="body-1 greyDarken1--text">{{
          $t("coupon_code.label.update.subtitle")
        }}</span>
      </div>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text class="pb-0" v-if="coupon">
      <v-layout row wrap>
        <v-flex xs12 md6>
          <!-- Coupon Id -->
          <v-layout row wrap class="subheading pb-1">
            <v-flex xs6 class="grey--text text--darken-1">
              {{ $t("screener.monetization.coupon.id") }}
            </v-flex>
            <v-flex xs6>
              {{ coupon.id }}
            </v-flex>
          </v-layout>

          <!-- Coupon Code -->
          <v-layout row wrap class="subheading justify-center align-center"  >
            <v-flex xs6 class="grey--text text--darken-1">{{
              $t("screener.monetization.coupon.code")
            }}</v-flex>
            <v-flex xs6>
              {{ coupon.code }}
              <v-tooltip slot="append" top color="white">
                <v-btn
                  slot="activator"
                  small
                  icon
                  dark
                  @click="copyToClipboard(coupon.code)"
                >
                  <v-icon small color="primary">$vuetify.icons.rms_copy</v-icon>
                </v-btn>
                <span class="greyDarken3--text body-1">{{
                  $t("screener.monetization.coupon.code_copy.tooltip")
                }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 md6>
          <!-- Numbers of Redemption  -->
          <v-layout row wrap class="subheading pb-1">
            <v-flex xs6 class="grey--text text--darken-1"
              >{{ $t("screener.monetization.coupon.number_of_redemption") }}
            </v-flex>
            <v-flex xs6>
              {{ coupon.no_of_used }}
            </v-flex>
          </v-layout>

          <!-- Status -->
          <v-layout row wrap class="subheading justify-center align-center">
            <v-flex xs6 class="grey--text text--darken-1">{{
              $t("rms.table.header.status")
            }}</v-flex>
            <v-flex xs6>
               <v-chip
                v-if="isDateFuture(coupon.start_date)"
                color="error"
                outline
                small
              >
                {{ $t("screener.status.inactive") }}
              </v-chip>
              <v-chip
                v-else-if="isDateFuture(coupon.end_date)"
                color="success"
                outline
                small
              >
                {{ $t("screener.status.active") }}
              </v-chip>
              <v-chip v-else color="error" outline small>
                {{ $t("screener.status.expired") }}
              </v-chip>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-divider class="my-4"></v-divider>
      <v-form ref="form" onsubmit="return false;">
         <v-text-field
            :label="$t('coupon_code.create.name.label')"
            name="name"
            :rules="[
              rules.required
            ]"
            color="primary"
            prepend-icon="$vuetify.icons.rms_agreement"
            type="text"
            v-model="coupon.name"
          ></v-text-field>
        <v-text-field
          :label="$t('coupon_code.create.discount.label')"
          name="discount"
          :rules="[
            rules.required,
            rules.floating_number,
            rules.inBetween(1, 100, coupon.discount)
          ]"
          color="primary"
          prepend-icon="$vuetify.icons.currency_usd"
          type="text"
          v-model="coupon.discount"
        ></v-text-field>
        <v-text-field
          :label="$t('coupon_code.create.redeem_limit.label')"
          name="discount"
          :rules="[rules.required, rules.numeric]"
          color="primary"
          prepend-icon="$vuetify.icons.rms_company_members"
          type="text"
          v-model="coupon.redeem_limit"
        ></v-text-field>
        <v-select
          :items="DEFINES.COUPON_TYPES"
          @change="onTypeChange"
          :label="$t('coupon_code.create.type.label')"
          item-value="value"
          v-model="coupon.type"
          prepend-icon="$vuetify.icons.screener_types"
        ></v-select>
        <v-autocomplete
          v-if="showSelectionInput"
          v-model="coupon.belongs_to"
          :items="monetizationPricings"
          chips
          color="blue-grey lighten-2"
          label="Select"
          item-text="name"
          item-value="id"
          multiple
          prepend-icon="$vuetify.icons.screener_group_ticket"
        >
          <template v-slot:selection="data">
            <v-chip
              :selected="data.selected"
              close
              class="chip--select-multi"
              @input="remove(data.item)"
            >
              {{ data.item.name }}
            </v-chip>
          </template>
          <template v-slot:item="data">
            <template>
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                <v-list-tile-sub-title
                  v-html="data.item.group"
                ></v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
        <v-autocomplete
          v-if="showEventSelection"
          v-model="coupon.belongs_to_screeners"
          :items="screeners"
          chips
          color="blue-grey lighten-2"
          label="Select event"
          item-text="title"
          item-value="id"
          multiple
          prepend-icon="$vuetify.icons.screener_group_ticket"
        >
          <template v-slot:selection="data">
            <v-chip
              :selected="data.selected"
              close
              class="chip--select-multi"
              @input="remove(data.item)"
            >
              {{ data.item.title }}
            </v-chip>
          </template>
          <template v-slot:item="data">
            <template>

              <v-list-tile-content>
                <v-list-tile-title
                  v-html="data.item.title"
                ></v-list-tile-title>
                <v-list-tile-sub-title
                  v-html="data.item.group"
                ></v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
        <v-layout row wrap justify-space-between>
          <v-flex xs12 md6>
            <DateTimePicker
              :label="$t('coupon_code.create.start_date.label')"
              datetime="start_date"
              v-model="coupon.start_date"
            />
            <!-- Showing local time regarding company configured timezone -->
            <ShowLocalTime
              :datetime="coupon.start_date"
              :timezone="timezone"
            ></ShowLocalTime>
          </v-flex>
          <v-flex xs12 md6>
            <DateTimePicker
              :label="$t('coupon_code.create.end_date.label')"
              datetime="end_date"
              v-model="coupon.end_date"
            />
            <!-- Showing local time regarding company configured timezone -->
            <ShowLocalTime
              :datetime="coupon.end_date"
              :timezone="timezone"
            ></ShowLocalTime>
          </v-flex>
        </v-layout>
        <v-switch v-model="coupon.published" color="primary">
            <template v-slot:label>
              <span v-if="coupon.published">{{$t('screener.save.form.published')}}</span>
              <span v-else>{{$t('screener.save.form.unpublished')}}</span>
            </template>
        </v-switch>
      </v-form>
    </v-card-text>
    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn
        :to="{
          name: 'company.coupon.index'
        }"
        color="grey"
        dark
      >
        {{ $t("rms.button.cancel") }}
      </v-btn>
      <v-btn dark color="secondary" @click.native="onUpdate()">
        {{ $t("rms.button.update") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import DEFINES from "@/defines";
import rules from "@/validation";
import i18n from "@/i18n";
import { mapState, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import moment from "moment";
import CouponCreate from "./CouponCreateDialog";
import { utcToTz, tzToUtc, isDateFuture } from "@/helper";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import DateTimePicker from "@/components/DateTimePicker";
import ShowLocalTime from "@/components/ShowLocalTime";

export default {
  name: "CouponSave",
  components: {
    CouponCreate,
    ConfirmationDialog,
    DateTimePicker,
    ShowLocalTime
  },
  data() {
    return {
      rules,
      monetizationPricings: [],
      dialog: false,
      moment,
      coupon: null,
      search: "",
      screeners:[]
    };
  },
  async beforeRouteEnter(to, from, next) {
    await next(vm => {
      vm.getCoupon();
    });
  },
  computed: {
    ...mapFields("coupon", {
      coupons: "list"
    }),
    ...mapGetters("company", {
      timezone: "getSelectedCompanyTimezone"
    }),
    showSelectionInput() {
      // console.log("input field", this.coupon.type);
      if (
        this.coupon.type == DEFINES.COUPON_TYPES_VALUE.FOLLOWING_SCREENING ||
        this.coupon.type == DEFINES.COUPON_TYPES_VALUE.EXPECT_THOSE_SCREENINGS
      ) {
        this.getPricingListFromApi(
          DEFINES.MONETIZATION.PRICING_TYPE.SINGLE_PURCHASE
        );
        return true;
      }

      if (
        this.coupon.type == DEFINES.COUPON_TYPES_VALUE.FOLLOWING_PASSES ||
        this.coupon.type == DEFINES.COUPON_TYPES_VALUE.EXPECT_THOSE_PASSES
      ) {
        this.getPricingListFromApi(
          DEFINES.MONETIZATION.PRICING_TYPE.GROUP_PURCHASE
        );
        return true;
      }

      if (
        this.coupon.type == DEFINES.COUPON_TYPES_VALUE.FOLLOWING_VOD_EVENTS ||
        this.coupon.type == DEFINES.COUPON_TYPES_VALUE.EXPECT_THOSE_VOD_EVENTS
      ) {
        this.getPricingListFromApi(
          DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE
        );
        return true;
      }
      return false;
    },
    showEventSelection() {
      if (
        this.coupon.type == DEFINES.COUPON_TYPES_VALUE.FOLLOWING_PHYSICAL_EVENTS ||
        this.coupon.type == DEFINES.COUPON_TYPES_VALUE.EXCEPT_FOLLOWING_PHYSICAL_EVENTS
      ) {
        this.getPhysicalTicket(
          DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE
        );
        return true;
      }
      return false;
    }
  },
  methods: {
    async getPricingListFromApi(type) {
      await this.$store
        .dispatch("monetization/listPricing", {
          type: type
        })
        .then(response => {
          this.monetizationPricings = response.pricing.data;
        })
        .catch(error => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
        });
    },

    async getCoupon() {
      var coupon;
      await this.$store
        .dispatch("coupon/get", {
          id: this.$route.params.coupon_id
        })
        .then(response => {
          coupon = response;
        })
        .catch(error => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
        });
      /**
       * convert utc time to company timezone
       */
      coupon.start_date = utcToTz(coupon.start_date, this.timezone);
      coupon.end_date = utcToTz(coupon.end_date, this.timezone);

      this.coupon = coupon;
    },
    onTypeChange(type) {
      this.coupon.belongs_to = [];
    },
    async onUpdate() {
      var coupon = Object.assign({}, this.coupon);

      // convert company timezone to UTC
      coupon.start_date = tzToUtc(coupon.start_date, this.timezone);
      coupon.end_date = tzToUtc(coupon.end_date, this.timezone);

      await this.$store
        .dispatch("coupon/update", coupon)
        .then(response => {
          this.$store.dispatch("app/showMessage", {
            message: "Updated successfully!",
            color: "success"
          });
        })
        .catch(error => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
        });
    },
    isDateFuture(date) {
      return isDateFuture( tzToUtc(date, this.timezone) );
    },
    copyToClipboard(item) {
      try {
        this.$copyText(item);
        this.$store.dispatch("app/showMessage", {
          message: i18n.t("coupon_code.copied.successfully"),
          color: "success"
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
    async getPhysicalTicket(type) {
      await this.$store
        .dispatch("screener/list", {
          event_types: [
            DEFINES.SCREENER_TYPE.PHYSICAL,
            DEFINES.SCREENER_TYPE.VIRTUAL_AND_PHYSICAL
          ]
        })
        .then(response => {
          // console.log(response);
          this.screeners = response.screeners.data;
        })
        .catch(error => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
        });
    },
  }
};
</script>


